/**
 * CustomerLabs Event Tracking
 * Відстежування подій для CustomerLabs CDP
 */

(function() {
    'use strict';

    // Check if tracking is blocked (ad blockers, privacy settings)
    let isTrackingBlocked = false;
    
    // Перевірка що CustomerLabs SDK завантажено
    function waitForCL(callback, onError) {
        let attempts = 0;
        const maxAttempts = 100; // 10 seconds with 100ms intervals
        
        const checkCL = setInterval(function() {
            attempts++;
            
            if (window._cl && typeof window._cl.track === 'function') {
                clearInterval(checkCL);
                isTrackingBlocked = false;
                callback();
            } else if (attempts >= maxAttempts) {
                clearInterval(checkCL);
                isTrackingBlocked = true;
                console.warn('[CustomerLabs] SDK not available. Tracking may be blocked by ad blockers or privacy settings.');
                if (onError) onError();
            }
        }, 100);
    }
    
    // Safe tracking wrapper
    function safeTrack(eventName, properties) {
        if (isTrackingBlocked) {
            console.log('[CustomerLabs] Tracking blocked, event not sent:', eventName);
            return;
        }
        
        try {
            if (window._cl && typeof window._cl.track === 'function') {
                _cl.track(eventName, properties);
                console.log('[CustomerLabs] ' + eventName + ' tracked:', properties);
            } else {
                console.warn('[CustomerLabs] SDK not ready for event:', eventName);
            }
        } catch (error) {
            console.error('[CustomerLabs] Error tracking event:', eventName, error);
        }
    }

    /**
     * 1. PageView Event
     * Автоматично відстежується CustomerLabs SDK
     */

    /**
     * 2. Product View Event
     * Викликається коли користувач вибирає state/patient type/veteran status
     */
    window.trackProductView = function(options) {
        waitForCL(function() {
            const properties = {
                customProperties: {
                    page_url: {
                        t: "string",
                        v: window.location.href
                    },
                    state: {
                        t: "string",
                        v: options.state || ""
                    },
                    patient_type: {
                        t: "string",
                        v: options.patientType || ""
                    },
                    veteran_status: {
                        t: "string",
                        v: options.veteranStatus ? "yes" : "no"
                    },
                    price_mode: {
                        t: "string",
                        v: options.priceMode || "standard"
                    },
                    price: {
                        t: "string",
                        v: options.price || ""
                    },
                    currency: {
                        t: "string",
                        v: "USD"
                    }

                }
            };
            
            safeTrack("Product View", properties);
        });
    };

    /**
     * 3. Added to Cart Event
     * Викликається при натисканні Book Now
     */
    window.trackAddedToCart = function(options) {
        waitForCL(function() {
            const properties = {
                customProperties: {
                    page_url: {
                        t: "string",
                        v: window.location.href
                    },
                    // booking_date: {
                    //     t: "string",
                    //     v: options.bookingDate || ""
                    // },
                    // booking_time: {
                    //     t: "string",
                    //     v: options.bookingTime || ""
                    // },
                    state: {
                        t: "string",
                        v: options.state || ""
                    },
                    patient_type: {
                        t: "string",
                        v: options.patientType || ""
                    },
                    price: {
                        t: "number",
                        v: parseFloat(options.price) || 0
                    },
                    value: {
                        t: "number",
                        v: parseFloat(options.price) || 0
                    },
                    currency: {
                        t: "string",
                        v: "USD"
                    }
                }
            };
            
            safeTrack("Added to Cart", properties);
        });
    };

    /**
     * 4. Checkout Event
     * Викликається при натисканні Continue на формі з інформацією клієнта
     */
    window.trackCheckout = function(options) {
        // Step 1: Identify user — requires CLabsgbVar.generalProps.uid to be ready
        var cl_identify = setInterval(function() {
            if (((window.CLabsgbVar || {}).generalProps || {}).uid) {
                clearInterval(cl_identify);

                var email = options.email || "";
                var phone = options.phone || "";

                var customProperties = {
                    user_traits: {
                        t: "Object",
                        v: {
                            first_name: {
                                t: "string",
                                v: options.firstName || ""
                            },
                            last_name: {
                                t: "string",
                                v: options.lastName || ""
                            },
                            email: {
                                t: "string",
                                v: email
                            },
                            phone: {
                                t: "string",
                                v: phone
                            }
                        }
                    },
                    external_ids: {
                        t: "Object",
                        v: {}
                    }
                };

                if (email && email != null && email != "") {
                    customProperties["identify_by_email"] = {
                        t: "string",
                        v: email,
                        ib: true
                    };
                    if (phone && phone != null && phone != "") {
                        customProperties["external_ids"]["v"]["identify_by_phone"] = {
                            t: "string",
                            v: phone
                        };
                    }
                } else if (phone && phone != null && phone != "") {
                    customProperties["identify_by_phone"] = {
                        t: "string",
                        v: phone,
                        ib: true
                    };
                }

                try {
                    if (customProperties.identify_by_email || customProperties.identify_by_phone) {
                        _cl.identify({ customProperties: customProperties });
                        console.log('[CustomerLabs] User identified:', email || phone);
                    } else {
                        console.warn('[CustomerLabs] No email or phone provided, skipping identify()');
                    }
                } catch (e) {
                    console.error('[CustomerLabs] identify() error:', e);
                }
            }
        }, 1000);

        // Step 2: Track Checkout event (uses standard _cl.track readiness check)
        waitForCL(function() {
            const properties = {
                customProperties: {
                    page_url: {
                        t: "string",
                        v: window.location.href
                    },
                    booking_date: {
                        t: "string",
                        v: options.bookingDate || ""
                    },
                    booking_time: {
                        t: "string",
                        v: options.bookingTime || ""
                    },
                    currency: {
                        t: "string",
                        v: options.currency || "USD"
                    },
                    value: {
                        t: "number",
                        v: parseFloat(options.value) || 0
                    }
                }
            };

            safeTrack("Checkout", properties);
            console.log('[CustomerLabs] Checkout event tracked for:', options.email);
        });
    };

    /**
     * 5. Purchase Event
     * Викликається на thank you page після успішної оплати
     */
    window.trackPurchase = function(options) {
        waitForCL(function() {
            const properties = {
                customProperties: {
                    page_url: {
                        t: "string",
                        v: window.location.href
                    },
                    currency: {
                        t: "string",
                        v: "USD"
                    },
                    value: {
                        t: "number",
                        v: parseFloat(options.value) || 0
                    },
                    order_id: {
                        t: "string",
                        v: options.orderId || ""
                    },
                    payment_method: {
                        t: "string",
                        v: options.paymentMethod || ""
                    }
                }
            };
            
            safeTrack("Purchase", properties);
        });
    };

    /**
     * 6. Payment Failed Event
     * Викликається якщо оплата не вдалася
     */
    window.trackPaymentFailed = function(options) {
        waitForCL(function() {
            const properties = {
                customProperties: {
                    page_url: {
                        t: "string",
                        v: window.location.href
                    },
                    currency: {
                        t: "string",
                        v: "USD"
                    },
                    value: {
                        t: "number",
                        v: parseFloat(options.value) || 0
                    },
                    error_message: {
                        t: "string",
                        v: options.errorMessage || ""
                    },
                    payment_method: {
                        t: "string",
                        v: options.paymentMethod || ""
                    }
                }
            };
            
            safeTrack("Payment Failed", properties);
        });
    };

    /**
     * Auto-track Product View при зміні селекторів
     * Викликається автоматично при зміні state/patient/veteran
     */
    function initAutoTracking() {
        waitForCL(function() {
            // Відстежуємо зміни в state dropdown
            const stateDropdown = document.querySelector('#state-dropdown');
            const patientDropdown = document.querySelector('#patient-dropdown');
            const veteranCheckbox = document.querySelector('#veteranCheck');

            if (stateDropdown && patientDropdown) {
                let trackingTimeout;
                
                const trackChanges = () => {
                    clearTimeout(trackingTimeout);
                    // Збільшений timeout для очікування завантаження цін з API
                    trackingTimeout = setTimeout(() => {
                        const state = stateDropdown.dataset.value || '';
                        const patientType = patientDropdown.dataset.value || '';
                        const veteranStatus = veteranCheckbox ? veteranCheckbox.checked : false;
                        
                        // Очікуємо додатковий час щоб ціни встигли завантажитися з backend
                        setTimeout(() => {
                            // Отримуємо поточну ціну і режим
                            // data-price-default
                            const visiblePrice = document.querySelector('.book__prices [data-price-default].is-visible, .book__prices [data-price-new].is-visible');
                            const price = visiblePrice ? visiblePrice.textContent.trim() : '';
                            // clean price text to number
                            const priceNumber = price ? parseFloat(price.replace(/[^0-9.]/g, '')) : 0;
                            
                            // Визначаємо price mode
                            let priceMode = 'standard';
                            if (patientType === 'new-patient' && veteranStatus) {
                                priceMode = 'veteran';
                            } else if (patientType === 'return-patient') {
                                priceMode = 'renewal';
                            } else if (patientType === 'transfer-patient') {
                                priceMode = 'transfer';
                            }

                            if (state && patientType) {
                                // Логуємо для debug якщо ціна не знайдена
                                if (!priceNumber) {
                                    console.warn('[CustomerLabs] Price not found yet, tracking without price');
                                }
                                
                                window.trackProductView({
                                    state: state,
                                    patientType: patientType,
                                    veteranStatus: veteranStatus,
                                    priceMode: priceMode,
                                    price: priceNumber
                                });
                            }
                        }, 800); // Додатковий timeout для завантаження цін з API
                    }, 500); // Debounce для уникнення множинних викликів
                };

                // Слухаємо зміни через MutationObserver для data-value
                const observer = new MutationObserver(trackChanges);
                observer.observe(stateDropdown, { attributes: true, attributeFilter: ['data-value'] });
                observer.observe(patientDropdown, { attributes: true, attributeFilter: ['data-value'] });
                
                if (veteranCheckbox) {
                    veteranCheckbox.addEventListener('change', trackChanges);
                }
            }
        });
    }

    // Ініціалізація після завантаження DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAutoTracking);
    } else {
        initAutoTracking();
    }

})();
